<template>
  <div class="box">
    <div class="tip-box">
      <Icon
        type="md-alert"
        size="38"
        color="#ff9900"
        style="display: inline-block;
  vertical-align: middle;"
      />
      <div class="modify-tip-box">
        <p>请定期更换登录密码，可以让你的账户更加安全。</p>
        <p>建议设置密码采用字母和数字混合。</p>
      </div>
    </div>
    <MySubmitForm
      v-model="params"
      style="width: 100%;"
      :label-width="130"
      :form-items="formList"
      :loading="submitLoading"
      cancel-text="返回登录页"
      @on-submit="onSubmit"
      @on-cancel="onCancel"
    >
    </MySubmitForm>
    <!-- 修改成功的弹框提示 -->
    <Modal
      v-model="modal"
      width="300"
      :closable="false"
      footer-hide
    >
      <div class="success-box">
        <Icon
          type="ios-checkmark-circle"
          size="40"
          color="#19be6b"
        />
        <p class="tip">
          密码找回成功,
          <MyCountDown
            v-if="colsetime"
            :time="colsetime"
            format="ss 秒"
            style="color: #f00; display: inline-block;"
            @finish="goLogin"
          />
          后请重新登录
        </p>
        <span
          class="login-btn"
          @click="goLogin"
        >立即登录</span>
      </div>
    </Modal>
  </div>
</template>

<script>
import MySubmitForm from '@/components/Template/SubmitForm';
import MyCountDown from '@/components/CountDown/index';
import md5 from 'js-md5';

export default {
  components: { MySubmitForm, MyCountDown },
  data() {
    return {
      modal: false,
      colsetime: 0,
      time: 0,
      detail: {},
      submitLoading: false,
      params: {
        appId: 'payCenterAdmin',

      },
      formShow: false,
      formList: [
        {
          label: '请输入新密码',
          placeholder: '请输入新密码',
          prop: 'newAccPwd',
          type: 'passwordEye',
          rules: [{ required: true, message: '请输入新密码', trigger: 'blur' },
            {
              required: true,
              validator: this.common.validate.password,
              trigger: 'blur',
            },
          ],
          tip: '必须是8-20位英文字母、数字或符号组合，不能是纯数字或纯字母',
        },
        {
          label: '再次输入新密码',
          placeholder: '请再次输入新密码',
          prop: 'newAccPwdConfirm',
          type: 'passwordEye',
          rules: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!rule.required && !value) {
                // 非必填时
                  callback();
                  return;
                }
                const { newAccPwd } = this.params;
                if (value.trim() !== newAccPwd.trim()) {
                  callback(new Error('两次密码输入不一致！'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
        },
        {
          label: '注册手机号码',
          placeholder: '请输入注册手机号码',
          prop: 'phone',

          type: 'input',
          rules: [
            { required: true, message: '请输入注册手机号码', trigger: 'blur' },
            {
              required: true,
              validator: this.common.validate.phone,
              trigger: 'blur',
            },
          ],
        },
        {
          label: '短信验证码',
          prop: 'smsCode',
          type: 'render',
          render: (h) => {
            const item = [];
            item.push(h('Input', {
              style: {
                width: '120px',
                marginRight: '10px',
              },
              props: {
                placeholder: '请输入短信验证码',
                value: this.params.smsCode,
                clearable: true,
              },
              on: {
                input: (smsCode) => {
                  this.params.smsCode = smsCode;
                },
              },
            }));
            if (this.time <= 0) {
              item.push(h('Button', {
                props: {
                  type: 'primary',
                  disabled: !this.params.phone,
                },
                on: {
                  click: () => {
                    this.sendCode();
                  },
                },
              }, '获取验证码'));
            } else {
              item.push(h(MyCountDown, {
                style: {
                  display: 'inline-block',
                },
                props: {
                  time: this.time,
                  format: 'ss 秒后重新获取',
                },
                on: {
                  finish: () => {
                    this.time = 0;
                  },
                },
              }, '发送验证码'));
            }

            return item;
          },
          tip: '',
          rules: [
            { required: true,
              validator: (rule, value, callback) => {
                if (!rule.required && !value) {
                // 非必填时
                  callback();
                  return;
                }
                const { key } = this.params;
                if (!key) {
                  callback(new Error('请先获取短信验证码！'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
            { required: true, message: '请输入短信验证码', trigger: 'blur' },
          ],
        },
      ],
    };
  },
  created() {

  },
  methods: {
    openModal() {
      this.modal = true;
      this.colsetime = 3000;
    },
    goLogin() {
      this.$router.push('/login');
    },
    // 发送短信
    sendCode() {
      const url = '/api/user/getSmsCode';
      const { appId, phone } = this.params;
      const params = {
        appId,
        phone,
        type: 3, //  0-登录 1-注册验证码 2-重置密码 3-找回密码
      };
      this.$http.post(url, this.common.utils.trim(params)).then(res => {
        const item = this.formList.find(ele => ele.prop === 'smsCode');
        if (res.success) {
          this.time = 60000;
          this.params.key = res.data.key;
          item.tip = '<p style="color:#f00;padding-top:10px;">短信验证码已经发送到你的手机，5分钟有效，请勿向陌生人泄露</p>';
          this.$Message.success('短信发送成功');
        } else {
          item.tip = '';
          this.$Message.warning(res.message || '短信发送失败');
        }
      });
    },
    onCancel() {
      this.$router.push('/login');
    },
    async onSubmit() {
      const { newAccPwd, phone, smsCode, key, appId } = this.common.utils.trim(this.params);
      const params = {
        newAccPwd: md5(newAccPwd.trim()),
        phone,
        smsCode,
        key,
        appId,
      };
      const url = '/api/user/accpwd/findPwd';
      this.submitLoading = true;
      const res = await this.$http.post(url, params);
      this.submitLoading = false;
      this.modal = false;
      if (res.success) {
        this.openModal();
      } else {
        this.$Message.warning(res.message || '操作失败');
      }
    },

  },
};
</script>

<style scoped lang="less">
.box {
  padding-top: 50px;
  width: 500px;
  margin: 0 auto;
}
.account-info {
  padding: 5px;
  margin: 10px 0;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #5e7ce0e8;
  box-shadow: 0 0 10px 1px #e7e7e7;
}
.applyAmount {
  color: #f00;
  padding: '5px 0';
}
.info-label {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
.tip-box {
  margin: 20px 0 30px;
  .modify-tip-box {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    margin-left: 10px;
    color: #999;
  }
}
.success-box {
  text-align: center;
  padding: 20px 0;
  .tip {
    padding: 20px 0;
    color: #999;
  }
  .login-btn {
    color: #2d8cf0;
    cursor: pointer;
  }
}
</style>
